import { render } from "./FeatureCard.vue?vue&type=template&id=737fc273&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"

import "./FeatureCard.vue?vue&type=style&index=0&id=737fc273&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737fc273"]])

export default __exports__